import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import _ from "lodash";

import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";

import { P } from "../Typography";

const BREAKPOINT = 700;
const optionProjectType = [
  { label: "Low Rise", value: "Low Rise" },
  { label: "High Rise", value: "High Rise" },
];
const optionsProjectStatus = [
  { label: "Sold Out", value: "Sold Out" },
  { label: "On Sale", value: "On-Sale" },
  { label: "On Hold", value: "On Hold" },
  { label: "Cancel", value: "Cancel" },
];
const optionsRoomType = [
  { label: "Studio", value: "Studio" },
  { label: "1 Bed", value: "1 Bed" },
  { label: "1 Bed Plus", value: "1 Bed Plus" },
  { label: "2 Bed", value: "2 Bed" },
  { label: "2 Bed Plus", value: "2 Bed Plus" },
  { label: "3 Bed", value: "3 Bed" },
  { label: "Other", value: "Other" },
];
const optionsRoomSize = [
  { label: "20-30 sq.m.", value: "20-30", min: 20, max: 30 },
  { label: "30-40 sq.m.", value: "30-40", min: 30, max: 40 },
  { label: "40-50 sq.m.", value: "40-50", min: 40, max: 50 },
  { label: "50-60 sq.m.", value: "50-60", min: 50, max: 60 },
  { label: "60-70 sq.m.", value: "60-70", min: 60, max: 70 },
  { label: "70-80 sq.m.", value: "70-80", min: 70, max: 80 },
  { label: "Over80 sq.m.", value: ">80", min: 81, max: "" },
];
const optionsPricePackage = [
  { label: "Under 1 mb", value: "0-999999", min: 0, max: 999999 },
  { label: "1mb-3mb", value: "1000000-3000000", min: 1000000, max: 3000000 },
  { label: "3mb-5mb", value: "3000000-5000000", min: 3000000, max: 5000000 },
  { label: "5mb-7mb", value: "5000000-7000000", min: 5000000, max: 7000000 },
  { label: "7mb-10mb", value: "7000000-10000000", min: 7000000, max: 10000000 },
  { label: "Over 10mb", value: ">10000000", min: 10000001, max: "" },
];

const Container = styled.div`
  width: 100%;
  height: 50px;
  background-color: #eb6323;
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 4px;
  /* padding: 10px 0; */
  @media (max-width: ${BREAKPOINT}px) {
    /* padding: 0; */
    height: auto;
    background-color: transparent;
  }
`;
const InputAreaSearchWrapper = styled.div`
  width: 80%;
  height: 100%;
  /* background-color: blue; */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: ${BREAKPOINT}px) {
    width: 95%;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
`;
const InputBudgetWrapper = styled.div`
  flex-basis: 50%;
  width: 50%;

  padding: 0;
  @media (min-width: ${BREAKPOINT}px) {
    padding: 0 4px;
    width: 20%;
  }
`;
// const StyledMUSelect = styled(Select)`
//   box-sizing: border-box;
//   display: block;
//   border-radius: 4px;
//   width: 100%;
//   background: white;
//   border: 1px solid #d9d9d9;
//   outline: none;
//   font-size: 14px;
//   height: 35px;
// `;
const LabelInput = styled(P)`
  margin: 0 !important;
`;

const dropdownStyle = {
  PaperProps: {
    style: {
      marginTop: 60,
    },
  },
};
const StyledMUSelect = {
  style: {
    boxSizing: "border-box",
    display: "block",
    borderRadius: 4,
    width: "100%",
    background: "white",
    border: "1px solid #d9d9d9",
    outline: "none",
    fontSize: 14,
    height: 35,
  },
};

const mapStateToProps = (state, ownProps) => {
  const { radius } = ownProps;
  return {};
};

export default connect(mapStateToProps)(
  class extends Component {
    state = {
      projectType: [],
      projectStatus: [],
      roomType: [],
      roomSize: [],
      pricePackage: [],
    };

    componentDidUpdate(prevProps) {
      if (this.props.query !== prevProps.query) {
        console.log("qq??", this.props.query);
        this.setState({
          projectType: _.get(this, "props.query.projectType.value", []),
          projectStatus: _.get(this, "props.query.projectStatus.value", []),
          roomSize: _.get(this, "props.query.roomSize.value", []),
          roomType: _.get(this, "props.query.roomType.value", []),
          pricePackage: _.get(this, "props.query.pricePackage.value", []),
        });
      }
    }

    handleChangeProjectType = (event) => {
      this.setState({ projectType: event.target.value });
      this.props.onFilterChange("projectType", event.target.value);
    };
    handleChangeProjectStatus = (event) => {
      this.setState({ projectStatus: event.target.value });
      this.props.onFilterChange("projectStatus", event.target.value);
    };
    handleChangeRoomType = (event) => {
      this.setState({ roomType: event.target.value });
      this.props.onFilterChange("roomType", event.target.value);
    };
    handleChangeRoomSize = (event) => {
      this.setState({ roomSize: event.target.value });
      this.props.onFilterChange("roomSize", event.target.value);
    };
    handleChangePricePackage = (event) => {
      this.setState({ pricePackage: event.target.value });
      this.props.onFilterChange("pricePackage", event.target.value);
    };

    render() {
      // const { query } = this.props;
      // const {
      //   projectType,
      //   projectStatus,
      //   roomSize,
      //   roomType,
      //   pricePackage,
      // } = query;
      return (
        <Container>
          <InputAreaSearchWrapper>
            <InputBudgetWrapper>
              <Select
                name="project-type"
                style={StyledMUSelect.style}
                disableUnderline={true}
                multiple
                value={this.state.projectType}
                onChange={this.handleChangeProjectType}
                input={<Input id="select-multiple-checkbox-project-type" />}
                displayEmpty
                MenuProps={dropdownStyle}
                renderValue={(selected) => {
                  if (_.size(selected) > 0) {
                    const selectedLabelArr = _.map(
                      _.filter(optionProjectType, (o) => {
                        return _.includes(selected, o.value);
                      }),
                      (bg) => bg.label
                    );
                    return selectedLabelArr.join(", ");
                  } else {
                    return <LabelInput>Project Type</LabelInput>;
                  }
                }}
              >
                {_.map(optionProjectType, (opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    <Checkbox
                      checked={_.includes(this.state.projectType, opt.value)}
                    />
                    <ListItemText primary={opt.label} />
                  </MenuItem>
                ))}
              </Select>
            </InputBudgetWrapper>
            <InputBudgetWrapper>
              <Select
                name="project-status"
                style={StyledMUSelect.style}
                disableUnderline={true}
                multiple
                value={this.state.projectStatus}
                onChange={this.handleChangeProjectStatus}
                input={<Input id="select-multiple-checkbox-project-status" />}
                displayEmpty
                MenuProps={dropdownStyle}
                renderValue={(selected) => {
                  if (_.size(selected) > 0) {
                    const selectedLabelArr = _.map(
                      _.filter(optionsProjectStatus, (o) => {
                        return _.includes(selected, o.value);
                      }),
                      (bg) => bg.label
                    );
                    return selectedLabelArr.join(", ");
                  } else {
                    return <LabelInput>Project Status</LabelInput>;
                  }
                }}
              >
                {_.map(optionsProjectStatus, (opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    <Checkbox
                      checked={_.includes(this.state.projectStatus, opt.value)}
                    />
                    <ListItemText primary={opt.label} />
                  </MenuItem>
                ))}
              </Select>
            </InputBudgetWrapper>
            <InputBudgetWrapper>
              <Select
                name="room-type"
                style={StyledMUSelect.style}
                disableUnderline={true}
                multiple
                value={this.state.roomType}
                onChange={this.handleChangeRoomType}
                input={<Input id="select-multiple-checkbox-room-type" />}
                displayEmpty
                MenuProps={dropdownStyle}
                renderValue={(selected) => {
                  if (_.size(selected) > 0) {
                    const selectedLabelArr = _.map(
                      _.filter(optionsRoomType, (o) => {
                        return _.includes(selected, o.value);
                      }),
                      (bg) => bg.label
                    );
                    return selectedLabelArr.join(", ");
                  } else {
                    return <LabelInput>Room Type</LabelInput>;
                  }
                }}
              >
                {_.map(optionsRoomType, (opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    <Checkbox
                      checked={_.includes(this.state.roomType, opt.value)}
                    />
                    <ListItemText primary={opt.label} />
                  </MenuItem>
                ))}
              </Select>
            </InputBudgetWrapper>
            <InputBudgetWrapper>
              <Select
                name="room-size"
                style={StyledMUSelect.style}
                disableUnderline={true}
                multiple
                value={this.state.roomSize}
                onChange={this.handleChangeRoomSize}
                input={<Input id="select-multiple-checkbox-room-size" />}
                displayEmpty
                MenuProps={dropdownStyle}
                renderValue={(selected) => {
                  if (_.size(selected) > 0) {
                    const selectedLabelArr = _.map(
                      _.filter(optionsRoomSize, (o) => {
                        return _.includes(selected, o.value);
                      }),
                      (bg) => bg.label
                    );
                    return selectedLabelArr.join(", ");
                  } else {
                    return <LabelInput>Room Size</LabelInput>;
                  }
                }}
              >
                {_.map(optionsRoomSize, (opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    <Checkbox
                      checked={_.includes(this.state.roomSize, opt.value)}
                    />
                    <ListItemText primary={opt.label} />
                  </MenuItem>
                ))}
              </Select>
            </InputBudgetWrapper>
            <InputBudgetWrapper>
              <Select
                name="price-package"
                style={StyledMUSelect.style}
                disableUnderline={true}
                multiple
                value={this.state.pricePackage}
                onChange={this.handleChangePricePackage}
                input={<Input id="select-multiple-checkbox-price-package" />}
                displayEmpty
                MenuProps={dropdownStyle}
                renderValue={(selected) => {
                  if (_.size(selected) > 0) {
                    const selectedLabelArr = _.map(
                      _.filter(optionsPricePackage, (o) => {
                        return _.includes(selected, o.value);
                      }),
                      (bg) => bg.label
                    );
                    return selectedLabelArr.join(", ");
                  } else {
                    return <LabelInput>Price Package</LabelInput>;
                  }
                }}
              >
                {_.map(optionsPricePackage, (opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    <Checkbox
                      checked={_.includes(this.state.pricePackage, opt.value)}
                    />
                    <ListItemText primary={opt.label} />
                  </MenuItem>
                ))}
              </Select>
            </InputBudgetWrapper>
          </InputAreaSearchWrapper>
        </Container>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/FilterBar/index.js